/**
 * Scalar funnel UI parameters that may cross the browser → BFF telemetry wire.
 *
 * This single contract is consumed at both redaction boundaries. Keeping the
 * allowlist here prevents the browser from silently dropping a field that the
 * BFF is prepared to accept (or vice versa).
 */
export const FUNNEL_UI_SAFE_PARAM_KEYS = [
  'source',
  'variantId',
  'blockType',
  'trigger',
  'scrollDepth',
  'action',
  'label',
  'eventType',
  'offerId',
  'productId',
  'cartId',
  'lineId',
  'leadRef',
  'formId',
  'quantity',
  'delta',
  'packId',
  'runtimeNavigationHandled',
  'cartItemCount',
  'cartTotal',
  'couponCode',
  'discountType',
  'discountValue',
  'businessEventId',
] as const;

export type FunnelUiSafeParamKey = (typeof FUNNEL_UI_SAFE_PARAM_KEYS)[number];
